<template>
  <div class="app-bar sticky top-0 bg-white shadow-md z-50">
    <UContainer class="app-bar-container">
      <div class="logo">
        <nuxt-link :to="{
          path: '/',
        }">
          <Logo />
        </nuxt-link>
      </div>
      <div class="search-bar">
        <UInputMenu v-model="selected" :search="search" :loading="loading" placeholder="Search..." color="primary"
          v-model:query="query" leading-icon="i-heroicons-magnifying-glass-20-solid" option-attribute="name" by="id"
          @keyup.enter="handleEnterKey" :ui-menu="{ height: 'max-h-full' }" @update:selected="handleSelection(selected)"
          class="ml-32 mr-28 flex-1" size="xl" :search-lazy="true" :popper="{
            arrow: false,
            locked: false,
            scroll: false,
            adaptive: true,
            strategy: 'absolute',
          }" @update:model-value="handleSelection">
          <template #trailing>
            <UButton v-if="query !== ''" color="gray" variant="link" icon="i-heroicons-x-mark-20-solid" :padded="false"
              @click="clearSearch()" />
          </template>
          <template #option="{ option: search }">
            <h4 class="truncate p-2 font-semibold">{{ search.name }}</h4>
          </template>
        </UInputMenu>
      </div>
      <div>
        <UDropdown :items="menuItems" :popper="{ placement: 'bottom-start', scroll: false }" mode="hover"
          class="w-fit min-w-0">
          <UButton size="xl" color="primary" mode="hover" class="border-0" :label="getAccountText()" variant="ghost"
            leading-icon="i-heroicons:user-circle-16-solid" trailing-icon="i-heroicons:chevron-down-16-solid" />
        </UDropdown>

        <NuxtLink :to="user === null ? '/login' : '/cart'">
          <UChip :text="cartStore.cartIds.length" size="2xl" v-if="categoryStore.showCartButton"
            :show="cartStore.cartIds.length > 0">
            <UButton size="xl" color="primary" mode="hover" class="border-0" label="Cart" variant="ghost"
              leading-icon="i-heroicons:shopping-cart-16-solid" />
          </UChip>
        </NuxtLink>

      </div>
    </UContainer>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useCategoriesStore } from "~/stores/categories";
import { useSearchStore } from "~/stores/search";
import { useUserStore } from "~/stores/user";
import type { EsAutoSuggestion } from "~/types/EsAutoSuggestion";
const router = useRouter();
const loginStore = useLoginStore()
const user = useCurrentUser();
const loading = ref(false);
const selected = ref();
const query = ref("");
const userStore = useUserStore();
const categoryStore = useCategoriesStore();
const cartStore = useCartStore();

const handleEnterKey = () => {
  if (query.value) {
    handleSelection(query.value)
  }
}
const handleSelection = async (selectedValue: any) => {
  console.log("Option selected:", selectedValue);
  await navigateTo
    ({
      path: '/products',
      query: {
        keyword: typeof (selectedValue) === 'string' ? selectedValue : selectedValue.name,
        page_num: 1,
        page_size: 12
      }
    })
  // router.push({ name: "products", params: { id: selectedValue } });
};

function clearSearch() {
  console.log("clicked clear");
  query.value = "";
  selected.value = "";
}

function getAccountText() {
  return userStore.user ? userStore.user?.nickname?.toString() : "My Account"
}

const searchStore = useSearchStore()
async function search(q: string): Promise<EsAutoSuggestion[]> {
  if (q == null) {
    return [];
  }
  loading.value = true;
  const searchSuggestions = await searchStore.searchAutoSuggestion(q)
  if (!user) {
    loading.value = false;
    return []
  }
  loading.value = false;

  return searchSuggestions ?? []
}

const items = ref([
  [{
    label: "LogIn/Sign up",
    class: "flex-1 font-medium text-base tracking",
    icon: "i-heroicons:user-16-solid",
    to: '/login',
  }],
  [{
    label: "My Profile",
    class: "flex-1 p-3 font-medium text-base tracking-wide",
    icon: "i-heroicons-pencil-square-20-solid",
    click: () => {
      console.log("Edit");
    },
    to: '/profile'
  },
  {
    label: "My Orders",
    class: "flex-1 p-3 font-medium text-base tracking-wide",
    icon: "i-heroicons-document-duplicate-20-solid",
    to: '/orders'
  },
  {
    label: "WishList",
    class: "flex-1 p-3 font-medium text-base tracking-wide",
    icon: "i-heroicons-archive-box-20-solid",
    to: '/wishlist'
  },
  {
    label: "Coupons",
    class: "flex-1 p-3 font-medium text-base tracking-wide",
    icon: "i-heroicons-arrow-right-circle-20-solid",
    to: '/coupons'
  }, {
    label: "Notifications",
    class: "flex-1 p-3 font-medium text-base tracking-wide",
    icon: "i-heroicons-arrow-right-circle-20-solid",
    to: '/notifications'
  }],
  [{
    label: "Logout",
    class: "flex-1 p-3 font-medium text-base tracking-wide",
    icon: "ion:log-out",
    click: () => {
      console.log("Logout");
      loginStore.signOutApp()
    },
  },
  ]
]);

const menuItems = computed(() => {
  return items.value.map(group => {
    return group.filter(item => {
      if (item.label === "LogIn/Sign up" && user.value !== null) {
        return false
      }
      if (item.label === "Logout" && user.value === null) {
        return false
      }
      return true;
    });
  }).filter(group => group.length > 0);
});

// watch(selected, (newValue, oldValue) => {
//   console.log("Selected item changed:", newValue);
//   if (newValue !== "") {
//     // router.push({ name: "products", params: { id: newValue.id } });
//   }
// });



onMounted(() => {
  router.beforeEach((to, from, next) => {
    if (to.name === 'cart') {
      categoryStore.toggleCartButton(false)
    } else {
      categoryStore.toggleCartButton(true)
    }
    next();
  })

  setTimeout(() => {
    if (userStore.user === undefined && user !== undefined && user.value !== null) {
      userStore.receiveUser()
    } else {
      console.log(userStore.user)
      console.log(user)
      console.log(user.value)
    }
  })
})

</script>

<style scoped>
.app-bar {
  position: sticky;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 12px 0;
  width: 100%;
  height: 70px;
  z-index: 1000;
}

.drop-down-item-class {
  font-size: xx-large;
}

.my-class {
  font-size: larger;
}

.app-bar-container {
  display: flex;
  align-items: center;
}

.logo img {
  height: 40px;
}

.search-bar {
  flex: 1;
  display: flex;
  justify-content: center;
}

.custom-dropdown-item {
  width: 200px;
  /* Adjust the width as needed */
  /* padding: 10px; Optional: adjust padding for better spacing */
  white-space: nowrap;
  /* Optional: prevent text from wrapping */
}
</style>
